import Waterfall from "@folksam/ui/components/animations/Waterfall";
import { useViewContext } from "@folksam/ui/providers/ViewContext";
import { useState } from "react";

import { Paragraph } from "../../atoms";
import { Box, Flex } from "../../cores";
import { useGetDescriptionConfig } from "../../hooks";
import { IconInfo } from "../../icons";
import { Button } from "../../molecules";
import { useTableContext } from "../../providers";
import { IDescription, IKeyStringAndValue, IOptions } from "../../types/Types";
import ContentDescription from "./ContentDescription";

type IContentDescriptionContainer = {
  columns: Array<IOptions>;
  filterOptions?: IKeyStringAndValue;
};

const ContentDescriptionContainer = ({
  columns,
  filterOptions,
}: IContentDescriptionContainer) => {
  const { listView } = useTableContext();
  const descriptionData = useGetDescriptionConfig(listView)
    .data as Array<IDescription>;
  const { isMobile } = useViewContext();
  const [iconDescriptionToggle, setIconDescriptionToggle] =
    useState<boolean>(false);
  const descriptionErrorNote = descriptionData.find(
    (el: IDescription) => el.name === "error_note"
  );
  const descriptionFacelift = descriptionData.find(
    (el: IDescription) => el.name === "facelift"
  );

  const handleToggle = (): void => {
    setIconDescriptionToggle((prevToggle) => !prevToggle);
  };
  if (descriptionData.length < 1) return <Box sx={{ marginBottom: "64px" }} />;
  return (
    <Flex
      sx={{
        flexDirection: "column",
        alignItems: "flex-end",
        marginX: "16px",
        marginBottom: "44px",
        "> div": {
          width: "100%",
          borderRadius: "12px",
          boxShadow:
            "0px 2px 5px -1px rgba(50, 50, 93, 0.25), 0px 1px 3px -1px rgba(0, 0, 0, 0.3)",
        },
        "> button": {
          marginBottom: "30px",
        },
      }}
    >
      <Button
        text={
          listView === "test_tabeller_varmesystem"
            ? `${iconDescriptionToggle ? "Göm" : "Visa"} begreppsförklaring`
            : `${iconDescriptionToggle ? "Göm" : "Visa"} teckenförklaring`
        }
        onClick={handleToggle}
        iconLeft={IconInfo}
        size={"md"}
        fullWidth={isMobile}
        variant={"outlined"}
      />
      <Waterfall animate={iconDescriptionToggle}>
        <Flex
          sx={{
            backgroundColor: "quinaryScale.2",
            flexDirection: "row",
            alignItems: "start",
            flexWrap: "wrap",
            padding: "15px",
            borderRadius: "12px",
            "> *": {
              paddingX: 20,
              marginY: "15px !important",
              "> *:first-of-type": {
                marginBottom: 4,
              },
            },
          }}
        >
          {columns.map((element) => {
            const descriptionValues = descriptionData.find(
              (el: IDescription) => element.key === el.name
            );
            const descriptionValuesPump = descriptionData.find(
              (el: IDescription) =>
                element.key + "|" + filterOptions?.typeOfPump === el.name
            );
            return (
              <ContentDescription
                filterOptions={filterOptions}
                element={element.key}
                key={element.key}
                descriptionTitle={
                  descriptionValues?.title !== undefined
                    ? descriptionValues?.title
                    : descriptionValuesPump?.title !== undefined
                    ? descriptionValuesPump.title
                    : ""
                }
                descriptionText={
                  descriptionValues?.description !== undefined
                    ? descriptionValues?.description
                    : descriptionValuesPump?.description !== undefined
                    ? descriptionValuesPump.description
                    : ""
                }
              />
            );
          })}
          {descriptionFacelift && (
            <Paragraph
              sx={{
                width: "100%",
              }}
            >
              {descriptionFacelift?.description}
            </Paragraph>
          )}
          {descriptionErrorNote && (
            <Paragraph
              sx={{
                fontSize: isMobile ? 12 : 14,
                fontStyle: "italic",
                width: "100%",
              }}
            >
              {descriptionErrorNote?.description}
            </Paragraph>
          )}
        </Flex>
      </Waterfall>
    </Flex>
  );
};

export default ContentDescriptionContainer;
